import { render } from "./templateFooterMaslenica.vue?vue&type=template&id=3d6c71ce&scoped=true"
import script from "./templateFooterMaslenica.vue?vue&type=script&lang=js"
export * from "./templateFooterMaslenica.vue?vue&type=script&lang=js"

import "./templateFooterMaslenica.vue?vue&type=style&index=0&id=3d6c71ce&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6c71ce"]])

export default __exports__